module.exports = __webpack_public_path__ + "img/Rectangle.f2041639.svg";